module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "chapter-one"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "appetizers-all-the-young-dudes-cooking-the-foods"
    }
  }, [_c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "rock-lobster-bisque"
    }
  }, [_c('h3', [_vm._v("Rock Lobster Bisque")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Another hearty meal from the East Coast. Add a touch of a B52 drink—the B52’s hit "), _c('strong', [_c('em', [_vm._v("Rock Lobster")]), _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v(",")])]), _vm._v(" and you are ready to Rock in East Coast style.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    }
  }, [_vm._v("https://www.youtube.com/watch?v=shBdbm7BNw0")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.82186in",
      "height": "3.21875in"
    },
    attrs: {
      "alt": "",
      "src": "media/file2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A bowl of food Description automatically generated with low confidence")])]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("Ingredients:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Two 2-pound rock lobsters (or regular lobsters), steamed")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("4 tablespoons butter")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/2 cup of sherry")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/2 cup chopped celery")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("3 cloves garlic, smashed")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 bay leaves")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1 teaspoon black peppercorns")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Sea salt to taste")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1 cup chopped red onion")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/2 cup chopped carrots")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/2 cup chopped button mushrooms")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 tablespoons tomato paste")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/8 teaspoon cayenne pepper. (You can also use a tablespoon of red-hot sauce as a substitute)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/2 cup dry white wine")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("3/4 cup whole milk")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/2 cup of half and half cream")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 tablespoons chopped fresh chives"), _c('strong', [_c('br')])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("Instructions")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("1. ")]), _vm._v("Twist off the claws and tails from the lobsters. (Rock lobsters do not have claws by the way. Remove the meat, discarding the green tomalley and reserving the shells. Coarsely chop the meat to measure about 2 1/2 cups and transfer it to a bowl; cover it and let it chill.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("2. ")]), _vm._v("Melt 2 tablespoons of the butter in a large pot over medium heat. Add the lobster shells, and cook, stirring often until lightly browned, for about 8 minutes. Stir in the sherry, and cook until the liquid is nearly evaporated, about 2 minutes. Add the celery, garlic, bay leaves, peppercorns, 4 cups water and 1/2 teaspoon salt. Increase up the heat for it to boil. Once achieved, reduce the heat to medium-low, and simmer until it is reduced to approx. 2 1/2 cups: for about 15 minutes. Pour through a fine-mesh strainer into a bowl; discard the solids and set it aside.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("3. ")]), _vm._v("Meanwhile, melt the remaining 2 tablespoons butter in an average sized skillet over medium heat. Add onions, carrots, mushrooms, tomato paste, cayenne and 1/2 teaspoon salt. Cook, stirring occasionally, until the vegetables are tender, for about 5 minutes. Add the wine and bring to a boil over medium-high. Reduce the heat to medium-low, add the reserved lobster stock and simmer until reduced to about 2 cups, for about 10 minutes. Then put it aside.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("4. ")]), _vm._v("Puree the mixture with an immersion blender until smooth. Place it over medium heat, stir in the milk and cream, and bring to a simmer. Add the lobster meat, reserving 1/4 cup for garnish.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("5. ")]), _vm._v("To serve, ladle the bisque into bowls and top with the reserved lobster meat and chives. For the decorative purposes, lay the tail partway into the bowl.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bda61350","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0003.vue
// module id = 87
// module chunks = 0